// extracted by mini-css-extract-plugin
module.exports = {"section10":"Section10_PH_section10__jmUTE"};